"use strict";

import FormValidator from "./form-validator";
import Toolbox from "./toolbox";
import Overlay from "./overlay";

/**
 * Lottery popup/overlay.
 * 
 * Usage: Lottery.show("1");
 * Where "1" is lottery pid.
 */


function disableEnableForm(mode = true) {
	const formArea = document.querySelector(".lottery-form-container");
	if (formArea) {
		for (const formElement of formArea.querySelectorAll("button[type=submit]")) {
			formElement.disabled = mode;
		}
	}
}

function initLotery() {
	const lotteryForms = document.querySelectorAll(".lottery-popup .lottery-content form");

	for (const lotteryForm of lotteryForms) {

		FormValidator(lotteryForm);

		lotteryForm.addEventListener("submit", function (e) {
			e.preventDefault();

			const form = e.target;
			if (form.checkValidity()) {
				const token = form.querySelector("input[name=token]");
				disableEnableForm(true);


				disableEnableForm(true);
				const registrationButton = form.querySelector("button[name=registration]");
				const registrationButtonText = registrationButton.textContent;
				registrationButton.textContent = "Odota...";

				Toolbox.getToken((StageToken) => {
					token.value = StageToken;
					form.submit();
				}, () => {
					registrationButton.textContent = "Tapahtui virhe. Lataa sivu uudelleen.";
					registrationButton.style.color = "black";
					setTimeout(() => {
						registrationButton.style.color = "";
						registrationButton.textContent = registrationButtonText;
						disableEnableForm(false);
					}, 3000);
				});

			}

		});
	}

}

function afterClose() {
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has("arvonta")) {
		urlParams.delete("arvonta");
		if (Array.from(urlParams.keys()).length === 0) {
			history.replaceState(null, "", window.location.pathname + window.location.hash);
		} else {
			history.replaceState(null, "", "?" + urlParams);
		}
	}
}

function show(lotteryId, settings) {

	if (!document.querySelector(".popup-lottery") && lotteryId !== undefined) {

		const _settings = {
			additionalClasses: ["popup-lottery"],
			closeText: "Sulje arvonta",
			mustache: true,
			view: {},
			init: initLotery, cleanup: afterClose
		};
		if (typeof settings === "object" && settings) {
			for (const key of Object.keys(settings)) {
				_settings[key] = settings[key];
			}
		}
		const template = document.querySelector("#lottery-template-" + lotteryId);
		if (template) {
			return Overlay.createOverlay(template.textContent, _settings);
		}
	}

	return false;

}

function showBySlug(init) {
	const urlParams = new URLSearchParams(window.location.search);
	if (init && urlParams.has("arvonta") && urlParams.get("arvonta") === init.slug) {
		show(init.lotteryId);
	}
}

export { show, showBySlug };

